import { map as mapPromise } from 'bluebird'
import { get as apiGet, TYPE_BROOKLYN_JSON } from 'api-client'
import { createAuthForRequest } from 'services/auth'

export async function getTerm (options = {}) {
  const { id, language, auth } = options
  const { body } = await apiGet(
    `term/${id}`,
    { language },
    {
      auth: createAuthForRequest({ auth, includeJwt: false }),
    },
    TYPE_BROOKLYN_JSON,
  )
  return body
}

export async function getTerms (options = {}) {
  const { ids, language, auth } = options
  return mapPromise(ids, async (id) => {
    try {
      return await getTerm({ id, language, auth })
    } catch (e) {
      return []
    }
  })
}
